import { combineReducers } from 'redux';
import {drawerReducer} from "./drawerReducer";

export const rootReducer = combineReducers({
    drawerReducer
});
